export default __webpack_public_path__ + "static/bombmoney-f8ccfe81ead0ac2c9d3d920d8c5b7741.jpg";